import { useCallback } from 'react';

function useThrottle(callback, delay) {
  const throttledCallback = useCallback((...args) => {
    let throttle;
    if (throttle) {
      clearTimeout(throttle);
    }
    throttle = setTimeout(() => {
      callback(...args);
      throttle = void 0;
    }, delay);
  }, [callback, delay]);
  return throttledCallback;
}

export { useThrottle };
//# sourceMappingURL=useThrottle.es.js.map
